var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMarkRead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2963 1.94967C10.2052 1.90066 10.1034 1.875 10 1.875C9.89659 1.875 9.7948 1.90066 9.70375 1.94967L2.23625 5.97092C1.93825 6.13134 1.68923 6.36942 1.51559 6.65992C1.34195 6.95041 1.25018 7.28249 1.25 7.62092V14.9997C1.25 15.6627 1.51339 16.2986 1.98223 16.7674C2.45107 17.2363 3.08696 17.4997 3.75 17.4997H16.25C16.913 17.4997 17.5489 17.2363 18.0178 16.7674C18.4866 16.2986 18.75 15.6627 18.75 14.9997V7.62092C18.7498 7.28249 18.658 6.95041 18.4844 6.65992C18.3108 6.36942 18.0617 6.13134 17.7638 5.97092L10.2963 1.94967ZM2.82875 7.07092L10 3.20842L17.1713 7.07092C17.2475 7.11213 17.3143 7.16875 17.3675 7.23717L10 11.1659L2.6325 7.23717C2.68568 7.16875 2.75251 7.11213 2.82875 7.07092ZM2.5 8.58342L9.70625 12.4247C9.79668 12.4728 9.89755 12.498 10 12.498C10.1024 12.498 10.2033 12.4728 10.2937 12.4247L17.5 8.58342V14.9997C17.5 15.3312 17.3683 15.6491 17.1339 15.8836C16.8995 16.118 16.5815 16.2497 16.25 16.2497H3.75C3.41848 16.2497 3.10054 16.118 2.86612 15.8836C2.6317 15.6491 2.5 15.3312 2.5 14.9997V8.58342Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarkRead);
export default __webpack_public_path__ + "static/media/ic-mark-read.b196114db674da8fc390a7ad95b0f19c.svg";
export { ForwardRef as ReactComponent };